var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7289 3.7376H25.1539V1.9501C25.1539 0.966972 24.3495 0.162598 23.3664 0.162598H9.06641C8.08328 0.162598 7.27891 0.966972 7.27891 1.9501V3.7376H3.70391C1.73766 3.7376 0.128906 5.34635 0.128906 7.31259V9.10009C0.128906 13.6582 3.56091 17.3762 7.97603 17.9303C9.10215 20.6116 11.5153 22.6315 14.4289 23.2213V28.7626H9.06641C8.08328 28.7626 7.27891 29.567 7.27891 30.5501C7.27891 31.5332 8.08328 32.3376 9.06641 32.3376H23.3664C24.3495 32.3376 25.1539 31.5332 25.1539 30.5501C25.1539 29.567 24.3495 28.7626 23.3664 28.7626H18.0039V23.2213C20.9175 22.6315 23.3307 20.6116 24.4568 17.9303C28.8719 17.3762 32.3039 13.6582 32.3039 9.10009V7.31259C32.3039 5.34635 30.6952 3.7376 28.7289 3.7376ZM3.70391 9.10009V7.31259H7.27891V14.1408C5.20541 13.3901 3.70391 11.4238 3.70391 9.10009ZM28.7289 9.10009C28.7289 11.4238 27.2274 13.3901 25.1539 14.1408V7.31259H28.7289V9.10009Z",
    fill: "#1C94B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiEvents);
export default __webpack_public_path__ + "static/media/emoji_events.1c21cdc90213c9f1c1f8ef1cca144229.svg";
export { ForwardRef as ReactComponent };